// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

// Other
import { colors } from 'common/styles/style-constants';

// Styles
const Container = styled.div`
  color: ${colors.coral};
  display: inline;
  margin: ${(props) => props.margin};

  & > svg {
    height: ${(props) => props.height};
    width: ${(props) => props.width};
  }
`;

// Component
const CheckShieldSvg = ({ height, margin, width }) => (
  <Container height={height} margin={margin} width={width}>
    <svg
      width="16px"
      height="19px"
      viewBox="0 0 16 19"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      <g
        id="Checkout"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Checkout_USA"
          transform="translate(-22.000000, -634.000000)"
          fill="#537087"
        >
          <g id="Group-3" transform="translate(22.000000, 634.000000)">
            <path
              d="M14.8516,1.12738273 C14.252,1.20358033 13.6514,1.22832087 13.0518,1.22832087 C11.502,1.22832087 10.00205,0.695915533 8.6768,0.214987533 C8.501995,0.138789933 8.3272,0.0883208667 8.1514,0.0378518 C7.976595,-0.0126172667 7.7764,-0.0126172667 7.626,0.0378518 C7.451195,0.0883208667 7.2764,0.164518467 7.1006,0.214987533 C5.7754,0.695915533 4.27535,1.22832087 2.7256,1.22832087 C2.126,1.22832087 1.501,1.20259233 0.9258,1.12738273 C0.70119,1.1016542 0.4512,1.1778518 0.2754,1.330247 C0.100595,1.4826422 -8.31335001e-13,1.710247 -8.31335001e-13,1.96358033 L-8.31335001e-13,10.8806603 C-8.31335001e-13,15.3139937 7.2245,18.6577403 7.54975,18.784407 C7.64936,18.8348761 7.77436,18.8606046 7.87495,18.8606046 C7.99995,18.8606046 8.09956,18.8348761 8.20015,18.784407 C8.49995,18.6320118 15.7499,15.3139937 15.7499,10.8806603 L15.7518525,1.96358033 C15.7518525,1.73597553 15.6522425,1.50737767 15.4764525,1.330247 C15.3016475,1.1778518 15.0770275,1.1026422 14.8514525,1.12738273 L14.8516,1.12738273 Z M14.1016,10.8807161 C14.1016,13.5158894 9.8771,16.1244627 7.8771,17.1132227 C5.8771,16.1256281 1.6526,13.5161427 1.6526,10.8807161 L1.6526,2.8758894 C2.0022,2.90161793 2.3528,2.90161793 2.7278,2.90161793 C4.553,2.90161793 6.27755,2.29402327 7.65255,1.81208193 C7.727745,1.7863534 7.827355,1.76161287 7.90255,1.73588433 C7.977745,1.76161287 8.077355,1.7863534 8.15255,1.81208193 C9.52755,2.29300993 11.2278,2.90161793 13.0773,2.90161793 C13.4269,2.90161793 13.8019,2.90161793 14.1525,2.8758894 L14.1525,10.8807161 L14.1016,10.8807161 Z"
              id="Fill-1"
            />
            <polygon
              id="Fill-2"
              points="6.42685 10.1711294 4.92685 8.6511294 3.75205 9.8425814 6.4268 12.5274081 12.4023 6.44740807 11.2519 5.2826574"
            />
          </g>
        </g>
      </g>
    </svg>
  </Container>
);
CheckShieldSvg.propTypes = {
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default CheckShieldSvg;
